// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".plainLink[data-v-17ca1926]{text-decoration:none!important}", ""]);
// Exports
module.exports = exports;
